import React, { useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate, Link } from 'react-router-dom';
import Logo from './Logo';
import '../styles/nav.css';

const LINKS = [
  { id: 'work', label: 'Projets' },
  { id: 'about', label: 'À propos' },
  { id: 'parcours', label: 'Parcours' },
  { id: 'contact', label: 'Contact' }
];

const SiteNav = () => {
  const [hidden, setHidden] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const lastY = useRef(0);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const onScroll = () => {
      const y = window.scrollY;
      setHidden(y > 160 && y > lastY.current);
      setScrolled(y > 40);
      lastY.current = y;
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const goTo = (e, id) => {
    e.preventDefault();
    setOpen(false);
    if (location.pathname === '/') {
      document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
    } else {
      navigate(`/#${id}`);
    }
  };

  return (
    <nav
      className={`nav ${hidden ? 'is-hidden' : ''} ${scrolled ? 'is-scrolled' : ''} ${
        open ? 'is-open' : ''
      }`}
    >
      <div className="shell nav-inner">
        <Link to="/" className="nav-mark" aria-label="Accueil — Kévin Gelineau">
          <Logo withWordmark size={26} />
        </Link>

        <button
          type="button"
          className="nav-burger"
          aria-expanded={open}
          aria-label={open ? 'Fermer le menu' : 'Ouvrir le menu'}
          onClick={() => setOpen((v) => !v)}
        >
          <span />
          <span />
        </button>

        <ul className="nav-links">
          {LINKS.map((link) => (
            <li key={link.id}>
              <a
                href={`/#${link.id}`}
                className="nav-link"
                onClick={(e) => goTo(e, link.id)}
              >
                {link.label}
              </a>
            </li>
          ))}
          <li>
            <a href="mailto:kevin.gelineau90@gmail.com" className="nav-cta">
              Me contacter
            </a>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default SiteNav;
